import { render } from "./GridCompras2Main.vue?vue&type=template&id=ac3eb1c6"
import script from "./GridCompras2Main.vue?vue&type=script&lang=js"
export * from "./GridCompras2Main.vue?vue&type=script&lang=js"

import "./GridCompras2Main.vue?vue&type=style&index=0&id=ac3eb1c6&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__